<template>
  <el-tooltip effect="dark" placement="top" :disabled="toolTipShow">
    <div slot="content">{{ innerContent }}</div>
    <div class="career" @mouseenter="handleEnter($event)">{{ innerContent }}</div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'tooltips',
  props: {
    innerContent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      toolTipShow: false
    }
  },
  methods: {
    handleEnter (e) {
      const ev = window.event || e
      const textContent = ev.target
      const scrollWidth = textContent.scrollWidth
      const offsetWidth = textContent.offsetWidth
      this.toolTipShow = scrollWidth <= offsetWidth
    }
  }
}
</script>
<style lang="scss" scoped>
.career {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 95%;
}
</style>
